import React from "react";

const Register: React.FC = () => {
  return <h1>Register Page</h1>;
};

export default Register;
